import React, { Component } from 'react'
import { graphql, Link } from 'gatsby'
import { Columns, Column, Container, Content, Hero, HeroBody, Subtitle, Title } from 'bloomer'
import styled from 'styled-components'

// import Breadcrumbs from '../../components/breadcrumbs'
import CallsToAction from '../../components/ctas'
import FontAwesome from '../../components/fontawesome'
import GetStarted from '../../components/start'
import Head from '../../components/head'
import Image from '../../components/image'
import Layout from '../../components/layout'
import Next from '../../components/next'

import windowWashingFeatures from '../../content/industries/window-washing'

/* CanIRank Updates */
const og = {
  socialTitle: 'Window Washing Software',
  socialDescription:
    'Route’s window washing software is designed to help you win more commercial cleaning business and exceed client expectations through improved bids and efficient field team management.'
}

const FeatureHighlight = styled.div`
  border-radius: 4px;
  height: 30rem;
  width: 100%;
`

const ShortHeroBody = styled(HeroBody)`
  @media only screen and (min-width: 45rem) {
    padding-top: 9rem !important;
  }
`

const HeroImage = styled(Image)`
  margin: 0 auto;
  width: 100%;
  z-index: 1;
`

const MobileMockupImage = styled(Image)`
  margin: 0 auto;

  @media only screen and (min-width: 45rem) {
    height: 50%;
    width: 50%;
  }
`

const WebMockupImage = styled(Image)`
  margin: 0 auto;
  height: 100%;
  width: 100%;
`

const ReversibleColumns = styled(Columns)`
  display: flex;
  flex-flow: column-reverse nowrap;

  @media only screen and (min-width: 45rem) {
    flex-flow: row nowrap;
  }
`

const RouteNationCard = styled.li`
  align-items: center;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  margin: 0 auto 2rem auto;
  transition: box-shadow 250ms ease 0s;

  :active,
  :focus,
  :hover {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 12px 24px;
  }

  @media only screen and (min-width: 45rem) {
    margin: 0 auto;
  }
`

const RouteNationCardContent = styled.div`
  align-items: center;
  display: flex;
  height: 128px;
  padding: 2rem 1rem;
`

const RouteNationCardLink = styled(Link)`
  color: rgba(11, 100, 233, 1);
  cursor: pointer;
  font-weight: 500;
`

class WindowWashing extends Component {
  render() {
    const featureHighlights = windowWashingFeatures.map((feature, i) => (
      <Column key={i} isSize={{ default: 4, mobile: 'full' }}>
        <FeatureHighlight>
          <Image alt={feature.title} file={this.props.data[feature.icon]} />
          <Subtitle isSize={4} style={{ fontWeight: 700, margin: '2rem 0' }}>
            {feature.title}
          </Subtitle>
          <Content isSize={'medium'} style={{ margin: '0 1rem' }}>
            {feature.description}
          </Content>
        </FeatureHighlight>
      </Column>
    ))

    const articles = this.props.data.RouteNation.edges.map(({ node }, index) => (
      <Column key={index} isSize={{ default: 4, mobile: 'full' }}>
        <RouteNationCard>
          <Image file={node.frontmatter.banner} style={{ height: '15rem', width: '100%' }} />
          <RouteNationCardContent>
            <Content isSize={'medium'} hasTextAlign={'centered'}>
              <RouteNationCardLink to={node.fields.slug}>{node.frontmatter.title}</RouteNationCardLink>
            </Content>
          </RouteNationCardContent>
        </RouteNationCard>
      </Column>
    ))

    let HeroSection = (
      <Hero isColor={'light'} isSize={'large'}>
        <ShortHeroBody>
          <Container hasTextAlign={'right'}>
            <Columns isCentered isVCentered>
              <Column isSize={{ default: 5, mobile: 'full' }} isHidden={`mobile`}>
                <HeroImage alt={'from walkthroughs to service'} file={this.props.data.infographic} />
              </Column>
              <Column isSize={{ default: 7, mobile: 'full' }}>
                <Title isSize={1} className={'huge'}>
                  Empowering Cleaning Companies With Window Washing Software
                </Title>
                <CallsToAction />
              </Column>
            </Columns>
          </Container>
        </ShortHeroBody>
      </Hero>
    )

    let FeatureHighlightsSection = (
      <Hero isColor={'black'} isSize={'medium'}>
        <HeroBody>
          <Container hasTextAlign={'centered'}>
            <Subtitle isSize={1}>Streamline Your Window Washing Business</Subtitle>
            <Subtitle isSize={2}>From walkthrough to new client, Route has the tools you need.</Subtitle>
            <Columns hasTextAlign={'centered'} isGrid style={{ justifyContent: 'center', marginTop: '4rem' }}>
              {featureHighlights}
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    let WalkthroughFeature = (
      <Hero isColor={'light'} isSize={'small'}>
        <HeroBody>
          <Container>
            <Columns hasTextAlign={'left'} isGrid isCentered isVCentered>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <MobileMockupImage
                  alt={'screenshot of window washing software walkthrough builder'}
                  file={this.props.data.walkthroughs}
                />
              </Column>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <Subtitle isSize={1}>Easily Record Walkthrough Details</Subtitle>
                <Content isSize={'large'} style={{ marginTop: '2.5rem' }}>
                  Buildings come in many shapes and sizes, and trying to record window washing details, such as the
                  total number of window panes, by hand can be painful. Route’s Walkthrough Builder&#8482; captures all
                  the details you need during the walkthrough from your mobile device: fixtures, square footage, photos,
                  measurements, notes and more.
                </Content>
                <Link
                  className={'learn-more-link'}
                  to={'/features/walkthrough-builder/'}
                  style={{ marginTop: '1.5rem' }}
                >
                  Learn About Walkthrough Builder&#8482;
                  <FontAwesome
                    alt={'learn more about the walkthrough builder feature'}
                    aria-label={'learn more about the walkthrough builder feature'}
                    className={'learn-more-icon'}
                    icon={['fa', 'arrow-alt-circle-right']}
                    style={{ marginLeft: '0.5rem' }}
                  />
                </Link>
              </Column>
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    let EstimatorFeature = (
      <Hero isColor={'light'} isSize={'medium'}>
        <HeroBody>
          <Container>
            <ReversibleColumns hasTextAlign={'left'} isGrid isCentered isVCentered>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <Subtitle isSize={1}>Window Washing Estimates Made Easy</Subtitle>
                <Content isSize={'large'} style={{ marginTop: '2.5rem' }}>
                  Simplify the process of creating estimates with Route’s Estimator. Just enter the total number of
                  window panes per building plus the rate for each pane. Then a reliable estimate is instantly
                  calculated and ready to share.
                </Content>
                <Link className={'learn-more-link'} to={'/features/estimator/'} style={{ marginTop: '1.5rem' }}>
                  Learn About Estimator
                  <FontAwesome
                    alt={'learn more about the estimator feature'}
                    aria-label={'learn more about the estimator feature'}
                    className={'learn-more-icon'}
                    icon={['fa', 'arrow-alt-circle-right']}
                    style={{ marginLeft: '0.5rem' }}
                  />
                </Link>
              </Column>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <Image
                  alt={'screenshot of window washing management software estimator'}
                  file={this.props.data.estimates}
                />
              </Column>
            </ReversibleColumns>
          </Container>
        </HeroBody>
      </Hero>
    )

    let ProposalFeature = (
      <Hero isColor={'light'} isSize={'medium'}>
        <HeroBody>
          <Container>
            <Columns hasTextAlign={'left'} isGrid isCentered isVCentered>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <WebMockupImage
                  alt={'screenshot of window washing management software proposal generator'}
                  file={this.props.data.proposals}
                />
              </Column>
              <Column isSize={{ default: 6, mobile: 'full' }}>
                <Subtitle isSize={1}>Modern Window Washing Proposals</Subtitle>
                <Content isSize={'large'} style={{ marginTop: '2.5rem' }}>
                  To get the modern heavily windowed office building clients, you need a modern proposal. Route’s
                  Proposal Generator lets you import the details from your walkthrough and add your service charges to
                  create a sleek proposal in minutes.
                </Content>
                <Link
                  className={'learn-more-link'}
                  to={'/features/proposal-generator/'}
                  style={{ marginTop: '1.5rem' }}
                >
                  Learn About Proposal Generator
                  <FontAwesome
                    alt={'learn more about the proposal generator feature'}
                    aria-label={'learn more about the proposal generator feature'}
                    className={'learn-more-icon'}
                    icon={['fa', 'arrow-alt-circle-right']}
                    style={{ marginLeft: '0.5rem' }}
                  />
                </Link>
              </Column>
            </Columns>
          </Container>
        </HeroBody>
      </Hero>
    )

    // let WorkflowFeature = (
    //   <Hero isColor={'light'} isSize={'medium'}>
    //     <HeroBody>
    //       <Container>
    //         <ReversibleColumns
    //           hasTextAlign={'left'}
    //           isGrid
    //           isCentered
    //           isVCentered
    //         >
    //           <Column isSize={{ default: 6, mobile: 'full' }}>
    //             <Subtitle isSize={1}>Enhance Team and Work Management</Subtitle>
    //             <Content isSize={'large'} style={{ marginTop: '2.5rem' }}>
    //               Managing a full schedule with many team members gets
    //               challenging. Use Route’s Workflow Management to easily assign
    //               team members to jobs and custom tasks. Keep tabs on job sites
    //               with shift management, real time progress updates, before and
    //               after photos and notes.
    //             </Content>
    //             <div className={'learn-more'}>
    //               <Link
    //                 className={'learn-more-link'}
    //                 to={'/features/workflow-management/'}
    //                 style={{ marginTop: '1.5rem' }}
    //               >
    //                 Learn More
    //                 <FontAwesome
    //                   alt={'learn more about the workflow management feature'}
    //                   aria-label={
    //                     'learn more about the workflow management feature'
    //                   }
    //                   className={'learn-more-icon'}
    //                   icon={['fa', 'arrow-alt-circle-right']}
    //                   style={{ marginLeft: '0.5rem' }}
    //                 />
    //               </Link>
    //             </div>
    //           </Column>
    //           <Column isSize={{ default: 6, mobile: 'full' }}>
    //             <MobileMockupImage
    //               alt={'Route Workflow Management for Window Washing Services'}
    //               file={this.props.data.workflows}
    //             />
    //           </Column>
    //         </ReversibleColumns>
    //       </Container>
    //     </HeroBody>
    //   </Hero>
    // )

    const RouteNationSection = (
      <Hero isColor={'light'} isSize={'medium'}>
        <HeroBody>
          <Container hasTextAlign={'centered'}>
            <Subtitle isSize={1}>Window Washing Resources</Subtitle>
            <Subtitle isSize={3} style={{ color: '#2a2a2a', fontWeight: 500 }}>
              From Route Nation
            </Subtitle>
            <ul style={{ marginTop: '4rem' }}>
              <Columns isCentered isGrid isMultiline isVCentered>
                {articles}
              </Columns>
            </ul>
          </Container>
        </HeroBody>
      </Hero>
    )

    return (
      <Layout>
        <Head
          author={'Route'}
          banner={this.props.data.infographic}
          title={'Window Washing Software'}
          description={`Route’s window washing software helps win business and exceed client expectations through improved bids, professional proposals and efficient field team management.`}
          keywords={['route window washing software']}
          {...og}
          {...this.props}
        />
        {/* <Breadcrumbs {...this.props} /> */}
        {HeroSection}
        {FeatureHighlightsSection}
        {WalkthroughFeature}
        {EstimatorFeature}
        {ProposalFeature}
        {/* WorkflowFeature */}
        {RouteNationSection}
        <Next to={'/industries/post-construction-cleaning'} title={'Next Up: Post Construction Cleaning'} />
        <GetStarted />
      </Layout>
    )
  }
}

export const query = graphql`
  query WindowWashingQuery {
    infographic: file(relativePath: { eq: "assets/infographics/service-infographic.png" }) {
      ...FluidImage
    }
    walkthroughs: file(relativePath: { eq: "assets/mockups/mobile/job-details-3.png" }) {
      ...FluidImage
    }
    estimates: file(relativePath: { eq: "assets/mockups/estimator.png" }) {
      ...FluidImage
    }
    proposals: file(relativePath: { eq: "assets/mockups/web/laptop-proposal-generator-1.png" }) {
      ...FluidImage
    }
    workflows: file(relativePath: { eq: "assets/mockups/mobile/clocked-in-job-3.png" }) {
      ...FluidImage
    }
    walkthroughBuilder: file(relativePath: { eq: "assets/icons/flaticon/walkthrough-builder.png" }) {
      childImageSharp {
        fixed(width: 160, height: 160) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    estimator: file(relativePath: { eq: "assets/icons/flaticon/estimator.png" }) {
      childImageSharp {
        fixed(width: 160, height: 160) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    proposalGenerator: file(relativePath: { eq: "assets/icons/flaticon/proposal-generator.png" }) {
      childImageSharp {
        fixed(width: 160, height: 160) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    workflowManagement: file(relativePath: { eq: "assets/icons/flaticon/workflow-management.png" }) {
      childImageSharp {
        fixed(width: 160, height: 160) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    RouteNation: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: ASC }
      filter: { frontmatter: { draft: { ne: true }, categories: { in: "window washing" } } }
    ) {
      edges {
        node {
          html
          excerpt
          timeToRead
          frontmatter {
            title
            banner {
              publicURL
              childImageSharp {
                fluid(maxWidth: 1080, quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                  presentationWidth
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`

export default WindowWashing
